import { render, staticRenderFns } from "./AppChip.vue?vue&type=template&id=01a564da&scoped=true&"
import script from "./AppChip.vue?vue&type=script&lang=ts&"
export * from "./AppChip.vue?vue&type=script&lang=ts&"
import style0 from "./AppChip.vue?vue&type=style&index=0&id=01a564da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a564da",
  null
  
)

export default component.exports